import { createUserWithEmailAndPassword } from 'firebase/auth';
import { authError } from '../../utils/errors.utils';
import { AuthState } from '../../interface/authState.interface';
import { AuthError } from '../../interface';

const onErrorSignUp = (_set: any, get: any, error: any) => {
    const { loginEmailFailure, loginPasswordFailure } = get();

    if (authError.isAlreadyInUse(error)) {
        loginEmailFailure(AuthError.EMAIL_ALREADY_IN_USE);
    } else if (authError.isInvalidEmail(error)) {
        loginEmailFailure(AuthError.INVALID_EMAIL);
    } else if (authError.isWeakPassword(error)) {
        loginPasswordFailure(AuthError.WEAK_PASSWORD);
    } else if (authError.isInvalidPassword(error)) {
        loginPasswordFailure(AuthError.WRONG_PASSWORD);
    } else {
        loginEmailFailure(AuthError.UNKNOWN_ERROR);
        loginPasswordFailure(AuthError.UNKNOWN_ERROR);
    }
};

export async function signup(set: any, get: any, email: string, password: string, confirmPassword?: string) {
    // Start loading
    set((state: AuthState) => ({ ...state, loading: true, errorCode: undefined })); // start loading

    const { firebaseAuth, loginEmailFailure, loginPasswordFailure } = get();

    let res;
    if (email === '') {
        loginEmailFailure(AuthError.MISSING_EMAIL);
    } else if (password === '') {
        loginPasswordFailure(AuthError.MISSING_PASSWORD);
    } else if (confirmPassword !== undefined && password !== confirmPassword) {
        loginPasswordFailure(AuthError.PASSWORDS_DONT_MATCH);
    } else {
        try {
            res = await createUserWithEmailAndPassword(firebaseAuth, email, password);
        } catch (error) {
            console.log(error);
            onErrorSignUp(set, get, error);
        }
    }

    return res;
}
